"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanLoadedType = void 0;
exports.getGAVKey = getGAVKey;
exports.loadReducers = void 0;
exports.loadType = loadType;
exports.unloadType = unloadType;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var actions = _interopRequireWildcard(require("./actionTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var isClient = (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) === 'object';
function getGAVKey(action) {
  return "".concat(action.groupId, "/").concat(action.assetId, "/").concat(action.version);
}
function loadType(assetType) {
  return {
    type: actions.LOAD_TYPE,
    assetType: assetType
  };
}
function unloadType() {
  return {
    type: actions.UNLOAD_TYPE
  };
}
var lastLoadedType;
var lastLoadedGAV;

// for testing purposes
var cleanLoadedType = exports.cleanLoadedType = function cleanLoadedType() {
  lastLoadedType = null;
  lastLoadedGAV = null;
};
var loadReducers = exports.loadReducers = function loadReducers(_ref) {
  var asset = _ref.asset,
    reducerManager = _ref.reducerManager,
    portalConfiguration = _ref.portalConfiguration;
  return function (dispatch) {
    var type = asset.type;
    if (isClient && type === lastLoadedType) {
      if (lastLoadedGAV === getGAVKey(asset)) {
        return null;
      }
      lastLoadedGAV = getGAVKey(asset);
      return portalConfiguration.default.onLoad;
    }
    lastLoadedType = type;
    reducerManager.load(portalConfiguration.default.reducers);
    dispatch(loadType(type));
    lastLoadedGAV = getGAVKey(asset);
    return portalConfiguration.default.onLoad;
  };
};
//# sourceMappingURL=actions.js.map